// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let SiteV2Api = class SiteV2Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param prescriberSiteId generated
     * @param applicationContext generated
     * @param roleType generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     */
    async prescriberSiteGet(prescriberSiteId, applicationContext, roleType, xTcScopeid, xTcScopetype) {
        const _url_ = '/site/v2/PrescriberSite/{prescriberSiteId}'
            .replace('{' + 'prescriberSiteId' + '}', encodeURIComponent(String(prescriberSiteId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'prescriberSiteId' is not null or undefined
        if (prescriberSiteId === null || prescriberSiteId === undefined) {
            throw new Error('Required parameter prescriberSiteId was null or undefined when calling prescriberSiteGet.');
        }
        if (applicationContext !== undefined) {
            _params_['applicationContext'] = Serializer.serialize(applicationContext, "string");
        }
        if (roleType !== undefined) {
            _params_['roleType'] = Serializer.serialize(roleType, "string");
        }
        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     *
     * @param id generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     * @param prescriberSiteListPostRequest
     */
    async prescriberSiteList(id, xTcScopeid, xTcScopetype, prescriberSiteListPostRequest) {
        const _url_ = '/site/v2/PrescriberSiteList/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling prescriberSiteList.');
        }
        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(prescriberSiteListPostRequest, "PrescriberSiteListPostRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     *
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     * @param prescriberSiteSearchPostRequest
     */
    async prescriberSiteSearch(xTcScopeid, xTcScopetype, prescriberSiteSearchPostRequest) {
        const _url_ = '/site/v2/PrescriberSiteSearch';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(prescriberSiteSearchPostRequest, "PrescriberSiteSearchPostRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     *
     * @param prescriberId generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     */
    async sitesByPrescriberGetByTenantId3(prescriberId, xTcScopeid, xTcScopetype) {
        const _url_ = '/site/v2/SitesByPrescriber/{prescriberId}'
            .replace('{' + 'prescriberId' + '}', encodeURIComponent(String(prescriberId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'prescriberId' is not null or undefined
        if (prescriberId === null || prescriberId === undefined) {
            throw new Error('Required parameter prescriberId was null or undefined when calling sitesByPrescriberGetByTenantId3.');
        }
        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
};
SiteV2Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], SiteV2Api);
export { SiteV2Api };
//# sourceMappingURL=siteV2Api.js.map